import React from 'react';
import PageShell from '@/components/PageShell';
import ContactSection from '@/components/sections/ContactSection';

const Contact = () => (
  <PageShell
    title="Contact Precision Vapour Blasting | Free Quote Christchurch"
    description="Get a free, no-obligation vapour blasting quote in Christchurch. Phone 022 657 8662, email info@precisionvapour.co.nz or visit Unit 2, 1 Doric Way, Islington."
    canonicalPath="/contact"
    crumbs={[{ name: 'Contact', path: '/contact' }]}
  >
    <ContactSection />
  </PageShell>
);

export default Contact;
